import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_WebGLCanvas = _resolveComponent("WebGLCanvas")!

  return (_openBlock(), _createBlock(_component_WebGLCanvas, {
    ref: "webglCanvas",
    onResize: _ctx.onResize,
    onMousedown: _ctx.onMousedown,
    onMousemove: _ctx.onMousemove,
    onMouseup: _ctx.onMoveend,
    onWheel: _ctx.onWheel,
    onClick: _ctx.onClick,
    onTouchstart: _ctx.onTouchstart,
    onTouchmove: _ctx.onTouchmove,
    onTouchend: _ctx.onMoveend,
    update: [_ctx.update, _ctx.complexPlane]
  }, null, 8, ["onResize", "onMousedown", "onMousemove", "onMouseup", "onWheel", "onClick", "onTouchstart", "onTouchmove", "onTouchend", "update"]))
}